import classNames from 'classnames';

export const ListItemIndicator: React.FC = () => {
  return <div className={classNames('w-2 h-2 rounded-full absolute top-[1px] left-[33px]')}></div>;
};
